// @flow weak

import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import Chart          from 'chart.js';
var Spinner = require('react-spinkit');
import {
  earningGraphMockData
}                     from '../../models';
import WorkProgressPanel  from '../../components/workProgress/workProgressPanel/WorkProgressPanel';
import fetchStatsGraphDataIfNeeded  from '../../redux/modules/actions';
import Panel          from '../panel/Panel';


class StatsGraph extends Component {

  constructor(props) {
    super(props);
    this.state        = { selectedLocation: props.selectedLocation } ;
  }



  componentDidMount() {
    const cardData = this.props.data[this.props.name];
    const { isFetching, requested_venue_id, venue_id } = cardData;
    this.drawChart({
      labels: cardData.labels,
      datasets: cardData.datasets
    });    
  }

  componentWillReceiveProps(newProps) {
    const cardData = this.props.data[this.props.name];
    const { isFetching, requested_venue_id, venue_id } = cardData;
    if(!isFetching){
      if(requested_venue_id != venue_id){
        console.log("StatsGraph - Location changed. Request data again");
        this.props.reloadData(requested_venue_id,this.props.name);
      }      
    }
    const { labels, datasets } = this.props;
    this.drawChart({
      labels: cardData.labels,
      datasets: cardData.datasets
    });    
  }

  handleClick(event,item){
    var chart = item[0]._chart.controller;
    var activePoint = chart.getElementAtEvent(event);
    console.log('activePoint',activePoint)
    if (activePoint.length > 0) {
      // Get current Dataset
      var dataset = activePoint[0]._datasetIndex;
      //get the internal index of slice in pie chart
      var clickedElementindex = activePoint[0]["_index"];
      //get specific label by index 
      var label = chart.data.labels[clickedElementindex];
      //get value by index      
      var value = chart.data.datasets[dataset].data[clickedElementindex];

      console.log('dataset',dataset)
      console.log('label',label)
      console.log('value',value)
      if(this.props.clickable){
        
      }
      } 
    }

  render() {
    const cardData = this.props.data[this.props.name];
    const { isFetching, requested_venue_id, venue_id } = cardData;
    console.log("StatsGraph requested_venue_id: " + requested_venue_id);
    console.log("StatsGraph venue_id: " + venue_id)
    if(!isFetching){
      if(requested_venue_id != venue_id){
        console.log("StatsGraph - Location changed. Request data again");
        this.props.reloadData(requested_venue_id,this.props.name);
      }      
    }    
    return (
      <Panel
        hasTitle={false}
        title={'Revenue Graph'}>
        <canvas
          ref={this.getCanvaRef}
          id="linechart"
          width="600"
          height="250"
        />
      </Panel>
    );      
  }
  getCanvaRef = ref => (this.linechart = ref)

  drawChart(data) {
    console.log("Drawing Chart")
    // BAR CHART
    const options = {
      responsive : true,
      maintainAspectRatio: true,
      onClick: (event,item)=>{this.handleClick(event,item)}
    };
    try{
      this.chart.destroy();
    }catch(e){

    }
      var ctx = this.linechart.getContext('2d')
      this.chart = new Chart(
      ctx,
      {
        type: this.props.type?this.props.type:'line',
        data,
        options
      }
    );

  }  
}

export default StatsGraph



// WEBPACK FOOTER //
// ./src/app/components/statsGraph/StatsGraph.js